var render, staticRenderFns
import script from "./MyHomeMixins.vue?vue&type=script&lang=ts&"
export * from "./MyHomeMixins.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.4.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "MyHomeMixins.vue"
export default component.exports